import { Table, TableProps } from "antd";
import { DataType } from "../../../models/interface/license.interface";
import { ColumnsExtend } from "./Column";
import PaginationComponent from "./Pagination";

const App = ({
  data,
  total,
  rowSelection,
}: {
  data: DataType[];
  total: number;
  rowSelection: TableProps<DataType>["rowSelection"];
}) => {
  return (
    <div className="border border-solid border-[#EBEEF2] rounded-lg">
      <Table<DataType>
        columns={ColumnsExtend}
        dataSource={data}
        rowSelection={rowSelection}
        pagination={false}
        rowKey={(record) => record.id?.toString() ?? ""}
        className="custom-table"
        scroll={{ x: 1600 }}
        tableLayout="fixed"
      />
      <PaginationComponent total={total} />
    </div>
  );
};

export default App;
